import { Component, OnInit } from '@angular/core';
import { ReferentielType } from 'src/app/fragments/modal/recherche-referentiel/recherche-referentiel.component';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { Header } from 'src/app/utils/interfaces/new/header.interface';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';

const loincEndpoint = 'https://bioloinc.fr/bioloinc/KB/';

@Component({
  selector: 'app-referentiels-medicaux',
  templateUrl: './referentiels-medicaux.component.html',
  styleUrls: ['./referentiels-medicaux.component.scss']
})
export class ReferentielsMedicauxComponent implements OnInit {

  public pageTitle = 'Référentiels médicaux';
  public refTypes = ReferentielType;
  public refsResult: Array<Referentiel> = [];
  public isLoading = false;

  constructor(
    private _send: HeaderCommunicationService,
    private _refSrv: ReferentielService
  ) {
    const head: Header = {
      backPage: 'utilitaires',
      isBack: true,
      title: this.pageTitle,
    };
    this._send.announceHeader(head);
  }

  ngOnInit(): void {
  }

  public async search(type: ReferentielType): Promise<void> {
    const _trimId = (id: string): string => {
      if (id.includes('++')) {
        return id.split('++')[0];
      } else {
        return id;
      }
    };

    this.refsResult = [];
    try {
      this.isLoading = true;
      if (type === ReferentielType['cisp-2']) {
        this.refsResult = await (await this._refSrv.findTerminologie(type));
      } else {
        const refs = await (await this._refSrv.findRefListTableHypermed(type));
        this.refsResult = refs.map(r => {
          return {
            id: _trimId(r.id),
            libelle: r.libelle
          };
        });
      }
    } catch (e) {
    } finally {
      this.isLoading = false;
    }
  }

  public async searchLoinc(): Promise<void> {
    window.open(loincEndpoint, '_blank');
  }

}
